import * as type from '../actions/types';

const initialState = {
  revenueDaily: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_REVENUE_DAILY_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.FETCH_REVENUE_DAILY_SUCCESS:
      return {
        ...state,
        revenueDaily: action.payload,
        loading: false,
        error: null,
      };

    case type.FETCH_REVENUE_DAILY_FAILURE:
      return {
        ...state,
        revenueDaily: null,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
